import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy } from '@angular/core';
import { Build } from '@portal-core/builds/models/build.model';
import { BuildsService } from '@portal-core/builds/services/builds.service';

@Component({
  selector: 'mc-build-progress-bar',
  templateUrl: './build-progress-bar.component.html',
  styleUrls: ['./build-progress-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuildProgressBarComponent {
  @Input() build: Build;
  @Input() showHeader?: boolean = true;
  @Input() showFooter?: boolean = true;

  get colorForBuildState(): string {
    return this.buildsService.getColorForBuild(this.build);
  }

  get textColorClassForBuildState(): string {
    return `mc-text-${this.colorForBuildState}`;
  }

  get statusDisplayText(): string {
    return this.buildsService.getStatusDisplayText(this.build);
  }

  get errorCount(): number {
    return this.build?.Process?.LastProcessAttempt?.ErrorCount ?? 0;
  }

  get warningCount(): number {
    return this.build?.Process?.LastProcessAttempt?.WarningCount ?? 0;
  }

  constructor(private buildsService: BuildsService) { }
}
